import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { TRIP, SEATS_LEFT, TRIP_DATE_ISO, whatsappUrl } from "../../data";
import { fadeUp, viewportOnce } from "../../lib/motion";

const target = new Date(TRIP_DATE_ISO).getTime();

const getTime = () => {
  const diff = Math.max(0, target - Date.now());
  const s = Math.floor(diff / 1000);
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
};

const pad = (n) => String(n).padStart(2, "0");

const Unit = ({ value, label, testid }) => (
  <div data-testid={testid} className="flex flex-col items-center px-3 sm:px-6">
    <span className="font-display font-light leading-none text-5xl sm:text-7xl lg:text-8xl text-ember tabular-nums">
      {pad(value)}
    </span>
    <span className="mt-3 font-body text-[0.6rem] sm:text-xs uppercase tracking-[0.25em] text-[var(--muted)]">{label}</span>
  </div>
);

export const Countdown = () => {
  const [t, setT] = useState(getTime());
  useEffect(() => {
    const id = setInterval(() => setT(getTime()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section data-testid="countdown" className="relative bg-ink-2 border-y border-white/10 py-20 sm:py-28">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="text-center mb-12 sm:mb-16">
          <div className="overline mb-5" style={{ color: "var(--ember)" }}>La cuenta atrás ha comenzado</div>
          <h2 className="font-display font-light text-4xl sm:text-6xl leading-[0.95] tracking-tight">
            El próximo grupo parte en <em className="italic text-ember">{TRIP.dates}</em>
          </h2>
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="flex items-start justify-center divide-x divide-white/10">
          <Unit value={t.days} label="Días" testid="countdown-days" />
          <Unit value={t.hours} label="Horas" testid="countdown-hours" />
          <Unit value={t.minutes} label="Minutos" testid="countdown-minutes" />
          <Unit value={t.seconds} label="Segundos" testid="countdown-seconds" />
        </motion.div>

        <div className="mt-14 flex flex-col items-center gap-5">
          <div className="inline-flex items-center gap-3 border border-white/15 px-5 py-2.5">
            <span className="h-2 w-2 rounded-full animate-pulse" style={{ backgroundColor: "var(--ember)" }} />
            <span className="font-body text-xs uppercase tracking-[0.2em] text-[var(--paper)]/80" data-testid="countdown-seats">
              Solo quedan {SEATS_LEFT} de {TRIP.seats.replace(" plazas", "")} plazas
            </span>
          </div>
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="countdown-cta"
            className="inline-flex items-center gap-3 px-8 py-4 font-body font-bold uppercase tracking-[0.15em] text-xs text-ink"
            style={{ backgroundColor: "var(--ember)" }}
          >
            Aún estás a tiempo — reserva tu plaza
          </a>
        </div>
      </div>
    </section>
  );
};
